'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { hasPricingAndPurchasingSucceededSelector } from '../../../selectors/LoadingStateSelectors';
import { calculatedPriceSelector } from '../../../selectors/PricingSelectors';
import { suiteProductConfigurationsSelector } from '../../../selectors/ProductConfigsSelectors';
import SuiteProductLevelIdentifiersMap from '../../../constants/SuiteProductLevelIdentifiersMap';
import { useValidatedCrmSuiteQueryParamTerm } from '../../../utils/stateUtils';
import { HighlightedPriceDisplay } from '../../common/pricing/HighlightedPriceDisplay';
import { quantityPackProductConfigurationsFromProductInventorySelector } from '../../../selectors/ProductInventorySelectors';
export const CrmSuitePrice = (_ref) => {
  let {
    productLevel,
    termOverride = null
  } = _ref,
      restProps = _objectWithoutPropertiesLoose(_ref, ["productLevel", "termOverride"]);

  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const {
    queryParamTerm
  } = useValidatedCrmSuiteQueryParamTerm({
    productLevel
  });
  const suiteProductConfigurations = useSelector(state => suiteProductConfigurationsSelector(state, {
    productLevel
  }));
  const ownedQuantityPackProductConfigurations = useSelector(state => {
    return quantityPackProductConfigurationsFromProductInventorySelector(state, {
      baseProductConfigurations: suiteProductConfigurations
    });
  });
  const checkoutProductConfigurations = [...suiteProductConfigurations, ...ownedQuantityPackProductConfigurations];
  const pricingInfo = useSelector(reduxState => {
    if (!hasPricingAndPurchasingSucceeded) return null;
    return calculatedPriceSelector(reduxState, {
      productConfigurations: checkoutProductConfigurations,
      queryParamTerm: termOverride || queryParamTerm
    });
  });
  return /*#__PURE__*/_jsx(HighlightedPriceDisplay, Object.assign({
    pricingInfo: pricingInfo,
    nonMerchandiseIdProduct: SuiteProductLevelIdentifiersMap[productLevel]
  }, restProps));
};